import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LandingComponent} from './pages/landing/landing.component';
import {FootfallWeekComponent} from './pages/footfall-week/footfall-week.component';
import {StoreDetailsComponent} from './pages/store-details/store-details.component';
import {EmployeesComponent} from './pages/employees/employees.component';
import {EmployeeDetailsComponent} from './pages/employee-details/employee-details.component';
import {LoginComponent} from './pages/login/login.component';
import {AuthGuard} from './auth/auth.guard';
import {AdminDebugComponent} from './pages/admin-debug/admin-debug.component';
import {UserGroupsComponent} from './pages/user/user-groups/user-groups.component';
import {Authority} from './classes/enums/Authority';
import {UsersComponent} from './pages/user/users/users.component';
import {RotaWeekComponent} from './pages/rota/rota-week/rota-week.component';
import {RotaDayComponent} from './pages/rota/rota-day/rota-day.component';
import {ExportRotaComponent} from './pages/rota/export-rota/export-rota.component';
import {UserActivityComponent} from './pages/user/user-activity/user-activity.component';
import {UserDetailsComponent} from './pages/user/users/user-details/user-details.component';


export const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'stores/:storeId',
    component: LandingComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_SEE_PREDICTIONS, Authority.AUTH_SEE_ROTAS]}
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'footfall-week/:weekId',
    component: FootfallWeekComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_SEE_PREDICTIONS]}
  },
  {
    path: 'rota-week/:weekId',
    component: RotaWeekComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_SEE_ROTAS]}
  },
  {
    path: 'rota-day/:date',
    component: RotaDayComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_SEE_ROTAS]}
  },
  {
    path: 'export-rotas',
    component: ExportRotaComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_SEE_ROTAS]}
  },
  {
    path: 'store-details/:id',
    component: StoreDetailsComponent,
    canActivate: [AuthGuard],
    data: {
      roles: [
        Authority.AUTH_SEE_TRADING_TIMES,
        Authority.AUTH_SEE_STORE_REQUIREMENTS,
        Authority.AUTH_SEE_STORE_BANKING,
        Authority.AUTH_SEE_STORE_CLOSED
      ]
    }
  },
  {
    path: 'employees/:storeId',
    component: EmployeesComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_SEE_EMPLOYEES]}
  },
  {
    path: 'employees/:storeId/:employeeId/:positionId',
    component: EmployeeDetailsComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_SEE_EMPLOYEES]}
  },
  {
    path: 'users',
    component: UsersComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_SEE_USERS]}
  },
  {
    path: 'users/:userEmail',
    component: UserDetailsComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_SEE_USERS]}
  },
  {
    path: 'user-statistics',
    component: UserActivityComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_SEE_USERS]}
  },
  {
    path: 'permissions',
    component: UserGroupsComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_MANAGE_USER_ACCESS]}
  },
  {
    path: 'admin-debug',
    component: AdminDebugComponent,
    canActivate: [AuthGuard],
    data: {roles: [Authority.AUTH_PERFORM_ADMINISTRATION]}
  },
];